import {
    Button,
    Dialog,
    DialogFooter,
    DialogHeader,
    DialogSimpleContent,
    DialogTitle,
} from '@/shared/ui'
import React from 'react'

type ConfirmDeleteDialogProps = {
    title: string
    message: string
    open: boolean
    onOpenChange: (open: boolean) => void
    onConfirm: () => void
    onCancel: () => void
}

export const ConfirmDeleteDialog: React.FC<ConfirmDeleteDialogProps> = ({
    message,
    title,
    open,
    onOpenChange,
    onConfirm,
    onCancel,
}) => {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogSimpleContent className="max-w-md rounded-2xl px-10 py-[30px]">
                <DialogHeader>
                    <DialogTitle className="text-2xl">{title}</DialogTitle>
                </DialogHeader>

                <div>
                    <p>{message}</p>
                </div>

                <DialogFooter className="justify-between gap-4">
                    <Button
                        className="m-0 w-full"
                        variant="error"
                        onClick={onConfirm}
                    >
                        Удалить
                    </Button>

                    <Button
                        className="m-0 w-full"
                        variant="secondary"
                        onClick={onCancel}
                    >
                        Отменить
                    </Button>
                </DialogFooter>
            </DialogSimpleContent>
        </Dialog>
    )
}
